import NotFoundScreen from '@/components/NotFoundScreen'

function NotFoundPage() {
  return <NotFoundScreen />
}

export default NotFoundPage
